import { BoxProps, HStack } from "@chakra-ui/react";
import { useRouter } from "next/router";
import { ITopTraderReaction } from "src/api/server/news.types";
import { FeedCardLayout } from "src/components/feed-card/common/feed-card-layout";
import { FeedCardUserReactionContent } from "src/components/feed-card/content-blocks/user-reaction/feed-card-user-reaction";
import { FeedCardActorContent } from "src/components/feed-card/feed-card-actor";
import { REACTION_SECTION_ID } from "src/components/pages/news/constants";
import { WatchlistButtonWrapper } from "./components/watchlist-button-wrapper";

interface IFeaturedTopTraderReactionCard extends BoxProps {
    topTraderReaction: ITopTraderReaction;
}

const NEWS_TRADER_REACTION_CARD_TEST_ID = "news-trader-reaction-card";

export const FeaturedTopTraderReactionCard = ({ topTraderReaction, ...boxProps }: IFeaturedTopTraderReactionCard) => {
    const router = useRouter();

    const onReactionBarClick = () => {
        router.replace(
            {
                pathname: window.location.pathname,
                hash: `#${REACTION_SECTION_ID}`,
            },
            undefined,
            { shallow: true }
        );
    };

    const { headerTitle, displayDate, actor, userReaction, watchlist } = topTraderReaction;

    return (
        <FeedCardLayout.Base {...boxProps} data-test-id={NEWS_TRADER_REACTION_CARD_TEST_ID}>
            <FeedCardLayout.Header>{headerTitle}</FeedCardLayout.Header>
            <FeedCardLayout.Content>
                <HStack justifyContent="space-between">
                    <FeedCardActorContent date={displayDate} {...actor} />
                    <WatchlistButtonWrapper
                        wikifolioId={watchlist.wikifolioId}
                        wikifolioShortDescription={watchlist.wikifolioShortDescription}
                        isOnWatchlist={watchlist.isOnWatchlist}
                    />
                </HStack>
                <FeedCardUserReactionContent onReactionBarClick={onReactionBarClick} {...userReaction} />
            </FeedCardLayout.Content>
        </FeedCardLayout.Base>
    );
};
